import { Breadcrumb } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { useT } from '../locales';

const ADMIN_BREADCRUMB_ROUTES = [
  { path: '/users', labelKey: 'nav.users' },
  { path: '/solicitudes', labelKey: 'nav.solicitudes' },
  { path: '/keycloak-orphans', labelKey: 'nav.keycloakOrphans' },
] as const;

interface AdminBreadcrumbsProps {
  current: string;
}

export function AdminBreadcrumbs({ current }: AdminBreadcrumbsProps) {
  const t = useT();
  const navigate = useNavigate();
  const menuItems = ADMIN_BREADCRUMB_ROUTES.map(({ path, labelKey }) => ({
    key: path,
    label: t(labelKey),
  }));

  return (
    <Breadcrumb
      separator=">"
      items={[
        { title: <Link to="/">{t('nav.home')}</Link> },
        {
          title: t('nav.admin'),
          menu: {
            items: menuItems,
            onClick: ({ key }) => {
              navigate(key);
            },
          },
          dropdownProps: { trigger: ['click'] },
        },
        { title: current },
      ]}
    />
  );
}
